import React, { useEffect, useState } from "react";
import { MessageCircle } from "lucide-react";
import { waLink, openExternal } from "../lib/contact";

/**
 * Sticky WhatsApp action button — bottom-left to avoid colliding with the
 * "Made with Emergent" badge at bottom-right. Appears after the user scrolls
 * past the hero.
 */
export default function StickyWhatsApp() {
  const [shown, setShown] = useState(false);

  useEffect(() => {
    const onScroll = () => setShown(window.scrollY > 500);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <a
      href={waLink("Hi AI For Everyone — I have a quick question.")}
      target="_blank"
      rel="noopener noreferrer"
      onClick={openExternal}
      aria-label="WhatsApp us"
      data-testid="sticky-whatsapp"
      className="fixed z-50 inline-flex items-center gap-2.5 px-4 py-3 rounded-full shadow-lg transition-all"
      style={{
        bottom: 22,
        left: 22,
        background: "#25D366",
        color: "#0A0E1F",
        boxShadow: "0 12px 30px -10px rgba(37,211,102,0.7), 0 0 0 4px rgba(37,211,102,0.12)",
        transform: shown ? "translateY(0)" : "translateY(120%)",
        opacity: shown ? 1 : 0,
        pointerEvents: shown ? "auto" : "none",
      }}
    >
      <MessageCircle size={18} strokeWidth={2} />
      <span className="text-[13px] font-medium hidden sm:inline">Chat on WhatsApp</span>
    </a>
  );
}
